import config from '../config'

export const ApiNames = {
  Submissions: config.Amplify.API.endpoints.find(endpoint => endpoint.name === 'modelapi').name
}

export const ApiEndpoints = {
  Submissions: config.Amplify.API.endpoints.find(endpoint => endpoint.name === 'modelapi').endpoint
}

export const Methods = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'del'
}
